export default __webpack_public_path__ + "static/media/chokingpowder.a2250543.png";